/* GENERATED FILE — DO NOT EDIT.
 *
 * W130 — the phone player's numbers and words, for the web's walk-through (`PhonePlayer.tsx`, `playerWalk.ts`), emitted
 * from the Swift the phone compiles: `W84PlayerFacts.swift` (W84PlayerRail, SpineLine, W84Steps, W84SetMark,
 * W131FinishPage, W133FinishPage), `SetRestPlan.swift`, `SectionSchedule.swift`, `WorkoutDifficulty.swift`, and — parsed
 * — `SpineTrack.swift` (liveRadius) and `HTLayout.swift` (minTapTarget). The words are the SwiftUI pages' own; the gate
 * finds each in the file named beside it.
 *
 * Regenerate:  KATA_EMIT_WEB_TOKENS=1 ./tools/engine-tests/run.sh
 * The harness gate `w130-the-coach-walks-the-workout` regenerates this in memory on every run and fails if it differs.
 */

/** `W84PlayerRail` — W141: one curve each side (peak `curveForward` over the line, `curveBack` under it), `groupPitch`
 *  between two superset members, the flame at `flameSize` beside the snowflake's `glyphSize`. */
export const RAIL = {
  minPitch: 15, glyphZone: 24, inset: 12, glyphGapExtra: 7,
  curveForward: 13, curveBack: 12, curveFoot: 6.5,
  arrowLength: 6, arrowHalfWidth: 4,
  groupPitch: 20, height: 30, lineY: 15.5,
  glyphSize: 16, flameSize: 15,
} as const;

/** `SpineLine` — W141: the line runs at full ink to `cupRadius` from a glyph's centre and joins its half circle, which
 *  runs `cupOverrun`° past each vertical; `cupFade` is `SpineLine.cupFade()` — (degrees off the facing, opacity). */
export const SPINE = {
  cupRadius: 11.5, cupOverrun: 20,
  dotRadius: 4.5, liveRadius: 6,
  dash: 4, legibleDashRun: 12,
  cupFade: [[45.230857941733035, 1], [77.61542897086652, 0.75], [101.90385724271663, 0.35], [110, 0]] as readonly (readonly [number, number])[],
} as const;

export const STEPS = { maxEven: 8, maxSlot: 44 } as const;

export const SET_MARK = { diameter: 26, ringWidth: 1.8 } as const;

/** `SetRestPlan.betweenWarmUpsCeiling` — the rest between two warm-up rungs never exceeds this. */
export const WARM_UPS_REST_CEILING = 60;

/** `SectionSchedule.isPlayed` — the formats the app runs a clock for. */
export const PLAYED_FORMATS: readonly string[] = ["circuit", "emom", "amrap", "timed_interval", "for_time"];

/** `WorkoutDifficulty.allCases` — the finish page's rating stops, 1…5. */
export const DIFFICULTY_LABELS: readonly string[] = ["Easy", "Moderate", "Challenging", "Difficult", "Too difficult"];

/** `W131FinishPage.noteLabel(coached: true)` and `.primaryTitle(completedAtSwipe:)`. */
export const NOTE_LABEL_COACHED = "Note for your coach";
export const SAVE_TITLE = "Save workout";

/** The pages' own words (each found in its SwiftUI file by the gate). */
export const WORDS = {
  start: "Start workout",
  continue: "Continue",
  endSome: "Check if you need to finish any exercise, or swipe below to save and end.",
  endAll: "Everything is logged. Swipe below to save and end.",
  swipe: "Swipe to end workout",
  notReady: "Not ready to end",
  floor: "Check off at least 1 set before you save.",
  workoutDone: "Workout done",
  howWasIt: "How was it?",
  slideToRate: "Tap or slide to rate",
  noteHint: "How did it go?",
  deleteWorkout: "Delete workout",
} as const;
